import { render, staticRenderFns } from "./EditCertification.vue?vue&type=template&id=c7bdacf6&scoped=true"
import script from "./EditCertification.vue?vue&type=script&lang=js"
export * from "./EditCertification.vue?vue&type=script&lang=js"
import style0 from "./EditCertification.vue?vue&type=style&index=0&id=c7bdacf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7bdacf6",
  null
  
)

export default component.exports